"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRouterState = exports.generateLoginFormState = exports.generateGeneralFormState = exports.generateUserState = void 0;
exports.generateUserState = function () { return ({
    user: "",
    email: "",
    password: "",
    userId: 0,
    clientId: 0,
    address: "",
    state: ""
}); };
exports.generateGeneralFormState = function () { return ({
    CompanyName: "",
    EffectiveDate: "",
    Phone: "(   )    -    ",
    Fax: "(   )    -    ",
    Address: "",
    City: "",
    State: "",
    Zip: 0,
    TaxIdNumber: "   -   -   "
}); };
exports.generateLoginFormState = function () { return ({
    email: "",
    password: ""
}); };
exports.generateRouterState = function () { return ({
    currentSection: 0
}); };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvcmVkdXgvc3RhdGljX2RhdGEvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBNEJhLFFBQUEsaUJBQWlCLEdBQXFCLGNBQU0sT0FBQSxDQUFDO0lBQ3hELElBQUksRUFBRSxFQUFFO0lBQ1IsS0FBSyxFQUFFLEVBQUU7SUFDVCxRQUFRLEVBQUUsRUFBRTtJQUNaLE1BQU0sRUFBRSxDQUFDO0lBQ1QsUUFBUSxFQUFFLENBQUM7SUFDWCxPQUFPLEVBQUUsRUFBRTtJQUNYLEtBQUssRUFBRSxFQUFFO0NBQ1YsQ0FBQyxFQVJ1RCxDQVF2RCxDQUFDO0FBRVUsUUFBQSx3QkFBd0IsR0FBNEIsY0FBTSxPQUFBLENBQUM7SUFDdEUsV0FBVyxFQUFFLEVBQUU7SUFDZixhQUFhLEVBQUUsRUFBRTtJQUNqQixLQUFLLEVBQUUsZ0JBQWdCO0lBQ3ZCLEdBQUcsRUFBRSxnQkFBZ0I7SUFDckIsT0FBTyxFQUFFLEVBQUU7SUFDWCxJQUFJLEVBQUUsRUFBRTtJQUNSLEtBQUssRUFBRSxFQUFFO0lBQ1QsR0FBRyxFQUFFLENBQUM7SUFDTixXQUFXLEVBQUUsYUFBYTtDQUMzQixDQUFDLEVBVnFFLENBVXJFLENBQUM7QUFFVSxRQUFBLHNCQUFzQixHQUEwQixjQUFNLE9BQUEsQ0FBQztJQUNsRSxLQUFLLEVBQUUsRUFBRTtJQUNULFFBQVEsRUFBRSxFQUFFO0NBQ2IsQ0FBQyxFQUhpRSxDQUdqRSxDQUFDO0FBRVUsUUFBQSxtQkFBbUIsR0FBK0IsY0FBTSxPQUFBLENBQUM7SUFDcEUsY0FBYyxFQUFFLENBQUM7Q0FDbEIsQ0FBQyxFQUZtRSxDQUVuRSxDQUFDIn0=